import { Reveal, SectionHeading } from "./Reveal";

export default function Events({ events }) {
  if (!events.length) return null;
  return (
    <section id="happenings" data-testid="events-section" className="relative overflow-hidden bg-lavender-950 py-24 lg:py-28">
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          light
          kicker="Happenings"
          title="News & events at the salon."
        />
        <div className="mt-12 grid gap-6 md:grid-cols-2" data-testid="events-grid">
          {events.map((e, i) => (
            <Reveal key={e.id || e.title} delay={0.08 * i}>
              <article
                data-testid={`event-card-${e.id || i}`}
                className="flex h-full gap-5 rounded-lg border border-white/10 bg-white/5 p-7 backdrop-blur transition-[background-color,transform] duration-500 hover:-translate-y-1 hover:bg-white/10"
              >
                <div>
                  {e.date ? <p data-testid={`event-date-${e.id || i}`} className="text-sm font-medium text-lavender-300">{e.date}</p> : null}
                  <h3 className="mt-1.5 font-bold text-xl text-white sm:text-2xl">{e.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-lavender-200">{e.description}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
